/* Shopify product and optional extra-tube checkout for the approved product page. */
(() => {
  'use strict';
  const form = document.getElementById('mv-buy-form');
  const configElement = document.getElementById('mp-commerce-config');
  if (!form || !configElement) return;
  const config = JSON.parse(configElement.textContent);
  // Refresh against the visitor's calendar, including cached pages and midnight rollover.
  const updateShippingDate = () => {
    const today = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'long',day:'numeric'}).format(new Date());
    document.querySelectorAll('[data-ship-date]').forEach(label => { label.textContent = today; });
  };
  updateShippingDate();
  window.setInterval(updateShippingDate, 60000);
  document.addEventListener('visibilitychange', updateShippingDate);
  window.addEventListener('pageshow', updateShippingDate);
  const button = form.querySelector('[type="submit"]');
  const bundles = [...form.querySelectorAll('.mv-bundle')];
  const addonInput = document.getElementById('mv-bump-check');
  const addon = config.addon?.variants?.find(variant => variant.available);
  const addonLabel = document.getElementById('mv-bump');
  const timer = document.getElementById('mv-bump-timer');
  const timerLine = timer?.closest('.mv-bt-line');
  const deadlineKey = 'meravae-display-countdown-v2';
  const offerDuration = (19 * 60 + 54) * 1000;
  let deadline = Date.now() + offerDuration;
  let submitting = false;
  let checkoutForm = null;
  // Temporary display countdown; offer eligibility is managed independently.
  const saveDeadline = () => {
    try { localStorage.setItem(deadlineKey, String(deadline)); } catch (_) { /* Continue in memory. */ }
  };
  try {
    const saved = Number(localStorage.getItem(deadlineKey));
    if (Number.isFinite(saved) && saved > Date.now() && saved <= deadline) deadline = saved;
  } catch (_) { /* Continue in memory. */ }
  saveDeadline();
  const variants = new Map((config.product?.variants || []).map(variant => [String(variant.id), variant]));
  const currency = config.currency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const root = (config.root || '/').replace(/\/?$/, '/');
  const status = document.createElement('p');
  status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden = true;
  form.append(status);
  const setStatus = message => { status.textContent = message; status.hidden = !message; };
  const selectedVariant = () => variants.get(form.querySelector('input[name="id"]:checked')?.value);
  const update = () => {
    for (const card of bundles) {
      const input = card.querySelector('input[name="id"]');
      const variant = variants.get(input.value);
      input.disabled = !variant?.available;
      card.classList.toggle('is-active', input.checked);
      if (!variant) continue;
      const units = variant.sku === 'meravae-cream-5' ? 5 : variant.sku === 'meravae-cream-3' ? 3 : 1;
      card.querySelector('.mv-b-now').textContent = money(Math.round(variant.price / units));
      card.querySelector('.mv-b-save').textContent = 'Save ' + money(Math.max(0,(variant.compare_at_price || variant.price)-variant.price));
    }
    const selected = selectedVariant();
    addonInput.disabled = !addon;
    addonLabel.hidden = !addon;
    if (!addon) addonInput.checked = false;
    const extra = addonInput.checked ? addon : null;
    const total = (selected?.price || 0) + (extra?.price || 0);
    const compare = (selected?.compare_at_price || selected?.price || 0) + (extra?.compare_at_price || extra?.price || 0);
    form.querySelector('[data-sum-now]').textContent = money(total);
    form.querySelector('[data-sum-was]').textContent = money(compare);
    form.querySelector('[data-sum-save]').textContent = money(Math.max(0,compare-total));
    button.disabled = submitting || !selected?.available;
    if (!variants.size) {
      setStatus('These bundles aren’t available for delivery to ' + (config.countryName || config.country || 'your selected country') + '.');
      // Missing market data is not a zero-dollar offer.
      form.querySelectorAll('[data-sum-now], [data-sum-was], [data-sum-save]').forEach(label => { label.textContent = '—'; });
    } else if (!selected?.available) {
      setStatus('These bundles are currently sold out.');
    } else setStatus('');
    if (addon) {
      document.querySelector('#mv-bump b').textContent = 'Add 1 extra tube for ' + money(addon.price);
      document.querySelector('#mv-bump s').textContent = money(addon.compare_at_price || addon.price);
    }
  };
  if (!selectedVariant()?.available) {
    const available = bundles.find(card => variants.get(card.querySelector('input').value)?.available);
    if (available) available.querySelector('input').checked = true;
  }
  form.addEventListener('change',update);
  const tick = () => {
    if (Date.now() >= deadline) {
      deadline = Date.now() + offerDuration;
      saveDeadline();
    }
    const seconds = Math.ceil((deadline - Date.now()) / 1000);
    if (timerLine) timerLine.hidden = !addon;
    if (timer) timer.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
  };
  tick();
  if (addon) window.setInterval(tick, 1000);
  document.addEventListener('visibilitychange',tick);
  window.addEventListener('storage', event => {
    if (event.key !== deadlineKey) return;
    const saved = Number(event.newValue);
    if (Number.isFinite(saved) && saved > Date.now() && saved <= Date.now() + offerDuration) deadline = saved;
    tick();
  });
  window.addEventListener('pageshow', () => {
    submitting = false;
    checkoutForm?.remove();
    checkoutForm = null;
    button.removeAttribute('aria-busy');
    tick();
    update();
  });
  update();
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (submitting) return;
    const selected = selectedVariant();
    if (!selected?.available) {update();return;}
    const items = [{id:selected.id,quantity:1}];
    if (addonInput.checked && addon) items.push({id:addon.id,quantity:1});
    submitting = true; button.disabled = true;button.setAttribute('aria-busy','true');setStatus('');
    try {
      // A single native navigation adds both items and continues to checkout.
      checkoutForm = document.createElement('form');
      checkoutForm.method = 'post';
      checkoutForm.action = root + 'cart/add';
      checkoutForm.hidden = true;
      const field = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = String(value);
        checkoutForm.append(input);
      };
      items.forEach((item, index) => {
        field('items[' + index + '][id]', item.id);
        field('items[' + index + '][quantity]', item.quantity);
      });
      field('return_to', root + 'checkout');
      document.body.append(checkoutForm);
      checkoutForm.submit();
    } catch (error) {
      checkoutForm?.remove();
      checkoutForm = null;
      setStatus(error.message || 'Please check your connection and try again.');
      submitting = false;button.disabled = false;button.removeAttribute('aria-busy');
    }
  });
  fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(response=>response.ok?response.json():null).then(cart=>{
    const counter=document.querySelector('.mv-site-header a[aria-label="Cart"] > span');
    if(counter&&cart)counter.textContent=String(cart.item_count);
  }).catch(()=>{});
})();
